import React from "react";
import "./Spinner.css";

interface SpinnerProps {
  align?: "left" | "center" | "right";
  className?: string;
  size?: "small" | "medium" | "large";
}

export const Spinner: React.FC<SpinnerProps> = ({
  align = "right",
  className = "",
  size = "medium",
}) => {
  return (
    <div className={`spinner-container spinner-align-${align} ${className}`}>
      <div className={`spinner spinner-${size}`} />
    </div>
  );
};
